import React, { Component } from 'react';

export default class CloudFlareBadge extends Component {
  componentDidMount() {
    const badgeType = this.props.type ? this.props.type : "g";
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async= true;
    s.setAttribute("data-cfbadgetype", badgeType);
    s.setAttribute("data-cfbadgeskin", "dkgray");
    s.src = '//ajax.cloudflare.com/cdn-cgi/nexp/cloudflare.js';
    this.securitybadge.appendChild(s);
  }
  render() {
    return (
      <div
        ref={el => (this.securitybadge = el)}
        className={this.props.type === "e" && "cloudflarebadge-e"}
      />
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/Layout/CloudFlareBadge.js
 **/